import React, { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { userRequest } from "../../utils/requestMethods";
import { useStateContext } from "../../contexts/ContextProvider";
import {
  AddStaffModal,
  EditStaffNameModal,
  StaffTable,
  MobileFriendlyNotification,
  GenerateStaffIDCardModal,
} from "../../components";

const TeacherManagement = () => {
  const history = useHistory();
  const location = useLocation();
  const { school } = useStateContext();
  const [teachers, setTeachers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isGenerateIdModalOpen, setIsGenerateIdModalOpen] = useState(false);
  const [editingTeacher, setEditingTeacher] = useState(null);
  const schoolId = school?._id;
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const fetchTeachers = async () => {
    if (schoolId) {
      try {
        setLoading(true);
        const { data } = await userRequest.get(`/teachers?school_id=${schoolId}&limit=500`);
        setTeachers(data.teachers || []);
      } catch (error) {
        console.log(error);
        setError(error.response?.data || "An unexpected error occurred.");
      } finally {
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    fetchTeachers();
  }, [schoolId]);

  const handleDelete = async (teacherId) => {
    try {
      await userRequest.delete(`/schools/${schoolId}/remove-staff/${teacherId}`);
      fetchTeachers();
      setSuccess("Staff removed successfully!");
    } catch (error) {
      console.log(error);
      setError(error.response?.data || "An unexpected error occurred.");
    }
  };

  const handleViewDetails = (teacher) => {
    history.push(`/management/teacher/${teacher._id}`, {
      teacher,
      assignClassId: location.state?.assignClassId,
    });
  };

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  return (
    <>
      {success && (
        <MobileFriendlyNotification
          type="success"
          message={success}
          onClose={() => setSuccess("")}
          autoClose={3000}
        />
      )}
      {error && (
        <MobileFriendlyNotification
          type="error"
          message={error}
          onClose={() => setError("")}
          autoClose={5000}
        />
      )}
      <StaffTable
        data={teachers}
        loading={loading}
        onDelete={handleDelete}
        onEdit={setEditingTeacher}
        onViewDetails={handleViewDetails}
        title="Teacher Management"
        onAddNew={toggleModal}
        addButtonText="Add New Teacher"
        onGenerateIdCards={() => setIsGenerateIdModalOpen(true)}
        generateIdCardsButtonText="Generate Staff ID Cards"
      />

      {isModalOpen && (
        <AddStaffModal
          onClose={toggleModal}
          schoolId={schoolId}
          onStaffAdded={fetchTeachers}
          role="teacher"
        />
      )}

      {editingTeacher && (
        <EditStaffNameModal
          onClose={() => setEditingTeacher(null)}
          schoolId={schoolId}
          staff={editingTeacher}
          onUpdated={fetchTeachers}
        />
      )}

      {isGenerateIdModalOpen && (
        <GenerateStaffIDCardModal
          isOpen={isGenerateIdModalOpen}
          onClose={() => setIsGenerateIdModalOpen(false)}
          teachers={teachers}
          schoolId={schoolId}
          school={school}
        />
      )}
    </>
  );
};

export default TeacherManagement;
